/** @format */

import { fromJS } from 'immutable';

const INITIAL_STATE = fromJS({
  isShowing: false,
  isSending: false,
  isSent: false,
  phoneNumber: '',
  error: false
});

export default function helpReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'SHOW_HELP_MODAL': {
      return state
        .set('isShowing', true)
        .set('isSending', false)
        .set('isSent', false)
        .set('error', false);
    }
    case 'HIDE_HELP_MODAL': {
      return state
        .set('isShowing', false)
        .set('phoneNumber', '')
        .set('error', false);
    }
    case 'HELP_INPUT_CHANGE': {
      return state.set('phoneNumber', action.payload.value);
    }
    case 'SENDING_HELP_STARTED': {
      return state.set('isSending', true).set('error', false);
    }
    case 'SENDING_HELP_DONE': {
      return state
        .set('isSending', false)
        .set('isSent', true)
        .set('error', false);
    }
    case 'SENDING_HELP_FAILED': {
      return state.set('isSending', false).set('error', action.payload.msg);
    }
    default: {
      return state;
    }
  }
}
